import React from "react";

export const Image = ({ title, subtitle, largeImage, smallImage }) => {
  return (
    <div className="portfolio-item">
      <div className="img-container">
        <div
          className="img-blur"
          style={{
            background: `url(${largeImage}) no-repeat center center`,
            backgroundSize: "cover",
          }}
        >
          {/* <div style={{ height: "450px" }}>a</div> */}
        </div>

        <img src={smallImage} className="img-responsive" alt={title} />
      </div>

      {/* <a href={largeImage} title={title} data-lightbox-gallery="gallery1"> */}
      {/* </a> */}
    </div>
  );
};
